import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ServiceRelationExpandButtonCtrl implements IController {
  service: any;
  isExpended: any;
  onExpand: Function;

  private relationList: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.relationList = [];

    let relationListRef = [];
    _.forEach(this.service.taskList, (t) => {
      relationListRef = relationListRef.concat(t.relations || [])
    });
    this.relationList = relationListRef;
  }

  $onChanges(changes) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceRelationExpandButton', {
    bindings: {
      service: '<',
      isExpended: '<',
      onExpand: '&'
    },
    template: require('./service-relation-expand-button.html').default,
    controller: ServiceRelationExpandButtonCtrl
  });
